/* FEAR UNIT — theme behaviours: live clock, mobile nav, hero video, cart drawer, qty */
(function () {
  'use strict';

  /* ---- live city clock ---- */
  function clocks() {
    document.querySelectorAll('[data-clock]').forEach(function (el) {
      var tz = el.getAttribute('data-clock') || 'UTC';
      function tick() {
        var s;
        try {
          s = new Date().toLocaleTimeString('en-GB', { timeZone: tz, hour12: false });
        } catch (e) {
          s = new Date().toLocaleTimeString('en-GB', { hour12: false });
        }
        el.textContent = s;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- mobile nav ---- */
  function nav() {
    var b = document.querySelector('[data-burger]');
    var n = document.querySelector('[data-nav]');
    if (!b || !n) return;
    b.addEventListener('click', function () {
      n.classList.toggle('is-open');
      b.setAttribute('aria-expanded', n.classList.contains('is-open'));
    });
  }

  /* ---- hero video play ---- */
  function hero() {
    document.querySelectorAll('[data-hero]').forEach(function (wrap) {
      var v = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-hero-play]');
      if (!v || !btn) return;
      btn.addEventListener('click', function () {
        if (v.paused) {
          v.play();
          btn.parentElement.classList.add('fu-hide');
        } else {
          v.pause();
        }
      });
      v.addEventListener('click', function () {
        if (!v.paused) {
          v.pause();
          btn.parentElement.classList.remove('fu-hide');
        }
      });
    });
  }

  /* ---- quantity steppers ---- */
  function qty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var input = b.parentElement.querySelector('input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += b.getAttribute('data-qty') === 'up' ? 1 : -1;
      input.value = Math.max(1, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- variant picker ---- */
  function variants() {
    document.querySelectorAll('[data-variants]').forEach(function (form) {
      var data = JSON.parse(form.querySelector('[data-variant-json]').textContent);
      var idInput = form.querySelector('[name="id"]');
      var priceEl = form.querySelector('[data-price]');
      var btn = form.querySelector('[data-add]');
      form.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(
          form.querySelectorAll('[data-opt]:checked, select[data-opt]'),
          function (i) { return i.value; }
        );
        var match = data.find(function (v) {
          return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (priceEl && match.price_formatted) priceEl.innerHTML = match.price_formatted;
        if (btn) {
          btn.disabled = !match.available;
          var lbl = btn.querySelector('[data-atc-label]') || btn;
          lbl.textContent = match.available ? btn.getAttribute('data-label') : btn.getAttribute('data-sold');
        }
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          history.replaceState({}, '', u);
        }
        var img = form.closest('.fu-pdp') && form.closest('.fu-pdp').querySelector('[data-main-img]');
        if (img && match.image) img.src = match.image;
      });
    });
  }

  /* ---- cart drawer ---- */
  var drawer = null;
  function openDrawer() {
    drawer = drawer || document.getElementById('FuCartDrawer');
    if (!drawer) return;
    drawer.hidden = false;
    renderCart();
  }
  function closeDrawer() {
    if (drawer) drawer.hidden = true;
  }
  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function renderCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = drawer.querySelector('[data-cart-body]');
        if (!cart.item_count) {
          body.innerHTML = '<div class="fu-empty fu-micro">Your bag is empty</div>';
          return;
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var t = (window.fuTheme || {});
        var meter = '';
        if (t.showMeter && t.threshold > 0) {
          var left = t.threshold - cart.total_price;
          var pct = Math.min(100, Math.round((cart.total_price / t.threshold) * 100));
          meter = '<div class="fu-meter"><p class="fu-micro--sm">' +
            (left > 0
              ? t.strings.progress + ' <strong>' + money(left) + ' ' + cart.currency + '</strong> ' + t.strings.progressSuffix
              : t.strings.unlocked) +
            '</p><div class="fu-meter__track"><span style="width:' + pct + '%"></span></div></div>';
        }
        var html = cart.items.map(function (i, idx) {
          return '<div class="fu-line">' +
            '<div class="fu-line__img">' + (i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="">' : '') + '</div>' +
            '<div><a class="fu-micro" href="' + i.url + '">' + i.product_title + '</a>' +
            '<div class="fu-micro--sm" style="margin-top:6px;opacity:.6">' + (i.variant_title || '') + ' &times; ' + i.quantity + '</div></div>' +
            '<div class="fu-micro">' + money(i.original_line_price) + ' ' + cart.currency + '</div>' +
            '<a class="fu-micro--sm" href="' + root + 'cart/change?line=' + (idx + 1) + '&quantity=0">Remove</a>' +
            '</div>';
        }).join('');
        html += '<div class="fu-cart__foot"><div class="fu-cart__total">Subtotal ' + money(cart.total_price) + ' ' + cart.currency + '</div>' +
          '<a class="fu-btn" href="' + root + 'checkout">Checkout</a>' +
          '<a class="fu-micro--sm" href="' + root + 'cart">View bag</a></div>';
        body.innerHTML = meter + html;
      });
  }
  function cart() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    document.querySelectorAll('[data-ajax-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add]');
        var lbl = btn ? (btn.querySelector('[data-atc-label]') || btn) : null;
        var label = lbl ? lbl.textContent : '';
        if (btn) { btn.disabled = true; }
        if (lbl) { lbl.textContent = 'ADDING…'; }
        fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function (item) {
            if (btn) { btn.disabled = false; }
            if (lbl) { lbl.textContent = label; }
            var added = (item && item.quantity) || 1;
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = (parseInt(el.textContent, 10) || 0) + added;
            });
            document.dispatchEvent(new CustomEvent('fu:added', { detail: { button: btn } }));
            openDrawer();
          })
          .catch(function () {
            if (btn) { btn.disabled = false; }
            if (lbl) { lbl.textContent = label; }
          });
      });
    });
  }

  /* ---- reveal on scroll ---- */
  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.style.opacity = 1; en.target.style.transform = 'none'; io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = 0;
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .7s ease, transform .7s cubic-bezier(.2,.7,.2,1)';
      io.observe(el);
    });
  }

  /* ---- countdown bars ---- */
  function countdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var out = el.querySelector('[data-countdown-out]');
      var target = new Date(el.getAttribute('data-countdown').replace(' ', 'T')).getTime();
      if (isNaN(target) || !out) return;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var d = target - Date.now();
        if (d <= 0) {
          out.textContent = el.getAttribute('data-expired-text') || '';
          return;
        }
        var days = Math.floor(d / 864e5);
        var h = Math.floor((d % 864e5) / 36e5);
        var m = Math.floor((d % 36e5) / 6e4);
        var s = Math.floor((d % 6e4) / 1000);
        out.textContent = (days > 0 ? days + 'D ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        requestAnimationFrame(function () { setTimeout(tick, 1000); });
      }
      tick();
    });
  }

  /* ---- sticky add to bag ---- */
  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var main = document.querySelector('.pdp [data-add], .fu-pdp [data-add]');
    if (!bar || !main) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(main);

    /* keep it in sync with the main variant picker */
    var form = document.querySelector('[data-variants]');
    if (!form) return;
    form.addEventListener('change', function () {
      var id = form.querySelector('[name="id"]');
      var price = form.querySelector('[data-price]');
      var sid = bar.querySelector('[data-sticky-id]');
      var sprice = bar.querySelector('[data-sticky-price]');
      var sbtn = bar.querySelector('[data-add]');
      if (id && sid) sid.value = id.value;
      if (price && sprice) sprice.textContent = price.textContent.replace(/\s+/g, ' ').trim();
      if (sbtn && main) {
        sbtn.disabled = main.disabled;
        var mainLbl = main.querySelector('[data-atc-label]');
        sbtn.textContent = (mainLbl ? mainLbl.textContent : main.textContent).trim();
      }
    });
  }

  /* ---- product recommendations ---- */
  function recs() {
    document.querySelectorAll('[data-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recs]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* ---- recently viewed ---- */
  var RV_KEY = 'fu:recently-viewed';
  function readRv() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function trackView() {
    var node = document.querySelector('[data-track-view]');
    if (!node) return;
    var p;
    try { p = JSON.parse(node.textContent); } catch (e) { return; }
    if (!p || !p.handle) return;
    var list = readRv().filter(function (i) { return i.handle !== p.handle; });
    list.unshift(p);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
  }
  function recentlyViewed() {
    var wrap = document.querySelector('[data-recently-viewed]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-recently-viewed-grid]');
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 4;
    var here = document.querySelector('[data-track-view]');
    var current = null;
    if (here) { try { current = JSON.parse(here.textContent).handle; } catch (e) {} }
    var items = readRv().filter(function (i) { return i.handle !== current; }).slice(0, limit);
    if (!items.length) return;
    grid.innerHTML = items.map(function (i) {
      return '<div class="fu-card">' +
        '<a class="fu-card__title" href="' + i.url + '">' + i.title + '</a>' +
        '<a class="fu-card__media" href="' + i.url + '">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="fu-card__meta"><span class="fu-card__opt">' + (i.option || '') + '</span>' +
        '<span class="fu-card__price fu-mono">' + (i.price || '') + '</span></div>' +
        '</div>';
    }).join('');
    wrap.hidden = false;
  }

  /* ---- welcome offer popup ---- */
  function popup() {
    var el = document.querySelector('[data-popup]');
    if (!el) return;
    var key = 'fu:popup-seen';
    var days = parseInt(el.getAttribute('data-days'), 10) || 14;
    var seen = parseFloat(localStorage.getItem(key) || '0');
    if (seen && Date.now() - seen < days * 864e5) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var delay = (parseInt(el.getAttribute('data-delay'), 10) || 8) * 1000;
    setTimeout(function () { el.hidden = false; }, delay);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) {
        el.hidden = true;
        try { localStorage.setItem(key, String(Date.now())); } catch (err) {}
      }
    });
  }

  /* ---- PDP: entry, gallery reveal, counter, progress, accordions ---- */
  function pdp() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* staggered panel entry */
    requestAnimationFrame(function () { root.classList.add('is-in'); });

    /* gallery reveal + active index */
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-shot]'));
    var idxOut = root.querySelector('[data-pdp-index]');
    function pad(n) { return String(n).padStart(2, '0'); }

    if ('IntersectionObserver' in window && !reduce) {
      var revealIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealIo.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      shots.forEach(function (s) { revealIo.observe(s); });

      var activeIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && idxOut) idxOut.textContent = pad(en.target.getAttribute('data-shot-index'));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      shots.forEach(function (s) { activeIo.observe(s); });
    } else {
      shots.forEach(function (s) { s.classList.add('is-in'); });
    }

    /* scroll progress across the PDP block */
    var bar = root.querySelector('[data-pdp-progress]');
    if (bar) {
      var onScroll = function () {
        var r = root.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var done = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
        bar.style.width = (done * 100).toFixed(2) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    /* height-animated accordions (native details, smooth open) */
    root.querySelectorAll('[data-acc-item]').forEach(function (d) {
      var c = d.querySelector('.pdp__acc-c');
      var sum = d.querySelector('summary');
      if (!c || !sum) return;
      var set = function (open) { c.style.height = open ? c.scrollHeight + 'px' : '0px'; };
      if (d.open) set(true);
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          set(false);
          c.addEventListener('transitionend', function done() {
            c.removeEventListener('transitionend', done);
            d.open = false;
          });
        } else {
          d.open = true;
          set(true);
        }
      });
      window.addEventListener('resize', function () { if (d.open) set(true); });
    });

    /* option value read-out next to each option label */
    var form = root.querySelector('[data-variants]');
    if (form) {
      var sync = function () {
        form.querySelectorAll('[data-opt]:checked').forEach(function (input) {
          var pos = (input.name.match(/\d+/) || ['1'])[0];
          var out = root.querySelector('[data-opt-value="' + pos + '"]');
          if (out) out.textContent = input.value;
        });
        var price = form.querySelector('[data-price]');
        var atcPrice = root.querySelector('[data-atc-price]');
        if (price && atcPrice) atcPrice.textContent = price.textContent.replace(/\s+/g, ' ').trim().split(' ').pop();
        var btn = root.querySelector('.pdp__atc');
        var label = root.querySelector('[data-atc-label]');
        if (btn && label) label.textContent = btn.disabled ? btn.getAttribute('data-sold') : btn.getAttribute('data-label');
      };
      form.addEventListener('change', function () { setTimeout(sync, 0); });
      sync();
    }
  }

  /* ---- add-to-bag button feedback ---- */
  function atcFeedback() {
    document.addEventListener('fu:added', function (e) {
      var btn = e.detail && e.detail.button;
      if (!btn) return;
      var label = btn.querySelector('[data-atc-label]') || btn;
      var prev = label.textContent;
      btn.classList.add('is-added');
      label.textContent = 'ADDED';
      setTimeout(function () {
        btn.classList.remove('is-added');
        label.textContent = prev;
      }, 1600);
    });
  }

  /* ---- INTRO GATE: 3D photo cylinder, inertia drag, one ENTER button ---- */
  function gate() {
    var el = document.querySelector('[data-gate]');
    if (!el || el.dataset.gateReady === '1') return;
    el.dataset.gateReady = '1';

    var design = !!(window.Shopify && window.Shopify.designMode);
    var KEY = 'fu:gate-seen';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (el.getAttribute('data-once') === 'true' && !design) {
      try { if (sessionStorage.getItem(KEY)) return; } catch (e) {}
    }

    var cards = Array.prototype.slice.call(el.querySelectorAll('[data-card]'));
    var counter = el.querySelector('[data-gate-counter]');
    if (!cards.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var maxR = parseFloat(el.getAttribute('data-radius')) || 780;
    var drift = (parseFloat(el.getAttribute('data-spin')) || 0) * 0.02;
    var n = cards.length;
    var step = 360 / n;
    var ring = el.querySelector('[data-gate-ring]');
    var radius = maxR;

    /* keep the ring behind the perspective origin so the front card sits at z≈0 */
    function sizeRing() {
      radius = Math.max(300, Math.min(maxR, window.innerWidth * 0.78));
      if (ring) ring.style.transform = 'translateZ(' + (-radius) + 'px)';
    }
    sizeRing();
    window.addEventListener('resize', function () { sizeRing(); place(current); });

    el.hidden = false;
    el.setAttribute('tabindex', '-1');
    document.body.classList.add('gate-open');

    /* stable pseudo-random offsets per card → organic, not a rigid ring */
    var meta = cards.map(function (c, i) {
      var s = Math.sin(i * 12.9898) * 43758.5453;
      var r = s - Math.floor(s);
      return { angle: i * step, y: (r - 0.5) * 92, roll: (r - 0.5) * 11, pitch: (r - 0.5) * 5 };
    });
    var live = cards.map(function () { return reduce; });

    function placeCard(i, t) {
      var m = meta[i];
      var a = m.angle + t;
      var depth = Math.cos(a * Math.PI / 180);
      cards[i].style.transform =
        'rotateY(' + a.toFixed(2) + 'deg) translateZ(' + radius + 'px)' +
        ' translateY(' + m.y.toFixed(1) + 'px)' +
        ' rotateY(' + (-a * 0.32).toFixed(2) + 'deg)' +
        ' rotateZ(' + m.roll.toFixed(2) + 'deg) rotateX(' + m.pitch.toFixed(2) + 'deg)';
      cards[i].style.opacity = Math.max(0, 0.16 + (depth + 1) / 2 * 0.94).toFixed(3);
      cards[i].style.zIndex = String(Math.round(depth * 100) + 200);
    }

    function place(t) {
      for (var i = 0; i < n; i++) { if (live[i]) placeCard(i, t); }
      if (counter) {
        var idx = ((Math.round(-t / step) % n) + n) % n;
        counter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
      }
    }

    var current = 0, target = 0;
    var dragging = false, lastX = 0;

    /* entrance — cards start clustered small at the centre, then fan out */
    if (!reduce) {
      cards.forEach(function (c, i) {
        c.style.transition = 'none';
        c.style.transform = 'translateZ(0px) scale(.28)';
        c.style.opacity = '0';
      });
      cards.forEach(function (c, i) {
        setTimeout(function () {
          c.style.transition = 'transform 1.2s cubic-bezier(.18,1.04,.3,1), opacity .85s ease';
          live[i] = true;
          placeCard(i, current);
          setTimeout(function () { c.style.transition = 'opacity .35s linear'; }, 1300);
        }, 140 + i * 60);
      });
      setTimeout(function () { el.classList.add('is-open'); }, 80);
    } else {
      el.classList.add('is-open');
      place(0);
    }

    /* input: wheel, drag, touch, arrows */
    el.addEventListener('wheel', function (e) {
      target -= (e.deltaY + e.deltaX) * 0.085;
      e.preventDefault();
    }, { passive: false });
    function down(x) { dragging = true; lastX = x; el.classList.add('is-drag'); }
    function move(x) {
      if (!dragging) return;
      target += (x - lastX) * 0.2;
      lastX = x;
    }
    function up() { dragging = false; el.classList.remove('is-drag'); }
    el.addEventListener('mousedown', function (e) { down(e.clientX); });
    window.addEventListener('mousemove', function (e) { move(e.clientX); });
    window.addEventListener('mouseup', up);
    el.addEventListener('touchstart', function (e) { down(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('touchend', up);
    document.addEventListener('keydown', function (e) {
      if (el.hidden) return;
      if (e.key === 'ArrowLeft') target += step;
      if (e.key === 'ArrowRight') target -= step;
    });

    /* loop: lerp toward target + slow idle drift */
    var raf;
    function loop() {
      if (!dragging) target -= drift;
      current += (target - current) * 0.085;
      place(current);
      raf = requestAnimationFrame(loop);
    }
    if (!reduce) loop();

    /* leave the gate */
    function enter(e) {
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      if (window.location.pathname !== root) return; /* let the link go home */
      if (e) e.preventDefault();
      el.classList.add('is-leaving');
      document.body.classList.remove('gate-open');
      setTimeout(function () {
        el.hidden = true;
        if (raf) cancelAnimationFrame(raf);
      }, 700);
    }
    var btn = el.querySelector('[data-gate-enter]');
    if (btn) btn.addEventListener('click', enter);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hidden) enter();
    });
  }

  function init() {
    clocks(); nav(); hero(); qty(); variants(); cart(); reveal();
    countdown(); stickyAtc(); recs(); trackView(); recentlyViewed(); popup();
    pdp(); atcFeedback(); gate();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
